import { render, staticRenderFns } from "./ImagesEditor.vue?vue&type=template&id=bcf8a8f6&scoped=true&"
import script from "./ImagesEditor.vue?vue&type=script&lang=js&"
export * from "./ImagesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ImagesEditor.vue?vue&type=style&index=0&id=bcf8a8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8a8f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
